import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../common/data.service';
import {SimpleCrypto} from "simple-crypto-js";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    private secretKey: string = environment.appcode;
    constructor(private _router: Router, private http: HttpClient, private _data: DataService) { }

    Autocomplete(url, keyword) {
        return this._data.PostData(url, { Param1: keyword, Param2: null });
    }

    Exit() {
        debugger;
        let _postbackURL = "home/dashboard";
        if (confirm('Are you sure you want to exit.')) {
            if (sessionStorage.getItem('callbackObject') != null) {
                let objForSearch: any = null;
                objForSearch = JSON.parse(sessionStorage.getItem('callbackObject'));
                if (objForSearch != null) {
                    _postbackURL = objForSearch.callbackUrl;
                }
            }
            this._router.navigate([_postbackURL]);
        }
    }

    UploadFile(files: any, empGPN: string) {
        const formData = new FormData();
        for (let file of files)
            formData.append(file.name, file);
        formData.append("EmployeeGPN", empGPN);
        return this._data.PostData('Common/UploadImage', formData);
    }

    BindCountryList() {
        return this._data.PostData('Resume/GetAllCountryList', null);
    }

    BindCityByCountryCode(str: string, CountryCode: string) {
        return this._data.PostData('Resume/GetCitiesByCountyID', { Param1: str, Param2: CountryCode });
    }
    BindQualificationList() {
        return this._data.PostData('Resume/GetAllQualifications', null);
    }
    BindCourseTypeList() {
        return this._data.PostData('Resume/GetAllCourseType', null);
    }
    BindCourseByQualification(str: string, QID: string) {
        return this._data.PostData('Resume/GetCourseListByQualification', { Param1: str, Param2: QID });
    }
    GetAllAuditTrailByID(id: any, className: string) {
        return this._data.PostData('Common/GetAllAuditTrailByID', { Param1: id, Param2: className });
    }
    EncryptData(data: string): string {
        let simpleCrypto = new SimpleCrypto(this.secretKey);
        let chiperText = simpleCrypto.encrypt(data);
        return chiperText.toString();
    }
    DecryptData(data: string): string {
        let simpleCrypto = new SimpleCrypto(this.secretKey);
        let chiperText = simpleCrypto.decrypt(data);
        return chiperText.toString();
    }
}
